import { JobType, WMICLogger } from 'wmic-pe-portals-utils-js';
import { LoadSaveService } from 'wmic-pe-capability-gateway-quoteandbind';
import { GatewayEndorsementService } from 'wmic-pe-capability-gateway-policychange';
import { GatewayRenewalService } from 'wmic-pe-capability-gateway-policyrenewal';

const postOnChange = (jobType, data, authHeader) => {
    switch (jobType) {
        case JobType.SUBMISSION:
            return LoadSaveService.postOnChange(data, authHeader);
        case JobType.POLICY_CHANGE:
            return GatewayEndorsementService.postOnChange(data, authHeader);
        case JobType.RENEWAL:
            return GatewayRenewalService.postOnChange(data, authHeader);
        default:
            const error = `Invalid jobType of ${jobType} for postOnChange`;
            WMICLogger.error(error);
            throw new Error(error);
    }
};

export default {
    postOnChange,
};
